
class PartnerService {
	async getPartnerId(){

		var queryString = {};
		const uri = '' + window.location;
		uri.replace(
			new RegExp("([^?=&]+)(=([^&]*))?", "g"),
			function ($0, $1, $2, $3) { queryString[$1] = $3; }
		);
		let partnerId = queryString.partnerId || this.NO_PARTNER;
		const json = { partnerId };
		return Promise.resolve(json);
	}
	NO_PARTNER = '';
}

const partnerService = new PartnerService();

export default partnerService;



// WEBPACK FOOTER //
// ./src/services/Partner.service.js